import { z } from 'zod';

/**
 * AI-controle of de regels van een samenstelling op elkaar aansluiten (issue #12): draad-/
 * poortmaten (bv. geluidsdemper ↔ magneetventiel 1/4" of 3/8"), asvierkant/ISO-flens tussen
 * afsluiter, koppel-/brugstuk en actuator, NAMUR-montage, stuurdruk vs. componenten.
 * Advies, geen harde validatie: de uitkomst blokkeert opslaan of pushen nooit.
 */
export const CheckCompatibilityBodySchema = z.object({
  product_id: z.number().int().positive(),
});
export type CheckCompatibilityBody = z.infer<typeof CheckCompatibilityBodySchema>;

export const CompatibilitySeveritySchema = z.enum(['error', 'warning', 'info']);
export type CompatibilitySeverity = z.infer<typeof CompatibilitySeveritySchema>;

/** Soort aansluiting waar een bevinding over gaat (voor het icoon in de UI). */
export const CompatibilityCategorySchema = z.enum(['thread', 'mounting', 'pressure', 'missing', 'other']);
export type CompatibilityCategory = z.infer<typeof CompatibilityCategorySchema>;

/** Verwijzing naar een regel (ook in een sub-product) waar een bevinding over gaat. */
export const CompatibilityLineRefSchema = z.object({
  line_id: z.number().int(),
  product_id: z.number().int(),
  label: z.string(),
});
export type CompatibilityLineRef = z.infer<typeof CompatibilityLineRefSchema>;

export const CompatibilityFindingSchema = z.object({
  severity: CompatibilitySeveritySchema,
  category: CompatibilityCategorySchema,
  title: z.string(),
  message: z.string(),
  suggestion: z.string().nullable(),
  lines: z.array(CompatibilityLineRefSchema),
});
export type CompatibilityFinding = z.infer<typeof CompatibilityFindingSchema>;

export const CompatibilityResultSchema = z.object({
  productId: z.number().int(),
  /** true = geen fouten gevonden (waarschuwingen/info kunnen er wel zijn) */
  ok: z.boolean(),
  summary: z.string(),
  findings: z.array(CompatibilityFindingSchema),
  /** Aantal regels (incl. die van sub-producten) dat aan de AI is voorgelegd */
  lineCount: z.number().int(),
  model: z.string(),
  checkedAt: z.string(),
});
export type CompatibilityResult = z.infer<typeof CompatibilityResultSchema>;
